import { withStyles, WithStyles, StyleRulesCallback, Theme, Typography, Checkbox } from '@material-ui/core';
import * as React from 'react';
import { pure } from 'recompose';
import { required, Validator } from '../../../shared/validation';
import FormTextField from '../../../components/FormTextField';
import { Field } from 'redux-form';
import { BpM } from '../../../shared/brakepoints';
import Translator from '../../../components/Translator';
import { defaultMemoize } from 'reselect';
import FormSelectField from '../../../components/FormSelectField';

type CssClasses = 'fieldContainer' | 'fullRow' | 'halfRow';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  fieldContainer: {
    display: 'flex',
    flexFlow: 'column',
    '& > *': {
      flex: '0 0 100%',
    },
    [BpM()]: {
      display: 'flex',
      margin: '0px -5px 0px',
      width: '500px',
      flexFlow: 'row wrap',
      '& > *': {
        flex: '0 0 250px',
        paddingLeft: '5px',
        paddingRight: '5px',
        maxWidth: '250px',
      },
    },
  },
  fullRow: {
    flex: '0 0 100%',
    maxWidth: '100%',
  },
  halfRow: {
    flex: '0 0 100%',
    maxWidth: '100%',
    [BpM()]: {
      '& > *': {
        width: '250px',
        paddingRight: '10px',
      },
    },
  },
});

interface State {
  alternative: boolean;
}

interface Props {}

class HuesgesAlternativeInspectionPlace extends React.Component<Props & WithStyles<CssClasses>, State> {
  state: State = {
    alternative: false,
  };

  private translatedRequire = defaultMemoize((translation: string) => {
    return required(translation);
  });

  private justRequired = defaultMemoize((requiredValidator: Validator) => {
    return [requiredValidator];
  });

  render() {
    let { classes } = this.props;
    return (
      <Translator>
        {translate => {
          const req = this.translatedRequire(translate('missing'));
          const justRequired = this.justRequired(req);
          return (
            <>
              <Typography variant={'h6'}>
                {translate('inspectionAlternativeTitle')}
                <Checkbox
                  style={{paddingTop: '10px'}}
                  checked={this.state.alternative}
                  onChange={this.handleAlternativeCheck}
                  value="checkedB"
                  color="primary"
                />{' '}
              </Typography>
              {this.state.alternative && (
              <div className={classes.fieldContainer}>
                <div className={classes.halfRow}>
                  <Field
                    name="alternativeName"
                    requireMark
                    component={FormTextField}
                    validate={justRequired}
                    label={translate('name')}
                    fullWidth={true}
                  />
                </div>

                <Field
                  name="alternativeStreet"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={translate('street')}
                  fullWidth={true}
                />
                <Field
                  name="alternativeHouseNumber"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={translate('housenumber')}
                  fullWidth={true}
                />
                <Field
                  name="alternativeZipCode"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={translate('zipCode')}
                  fullWidth={true}
                />
                <Field
                  name="alternativeCity"
                  requireMark
                  component={FormTextField}
                  validate={justRequired}
                  label={translate('city')}
                  fullWidth={true}
                />
              </div>)}
            </>
          );
        }}
      </Translator>
    );
  }

  private handleAlternativeCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ alternative: event.target.checked });
  };
}

export default pure(withStyles(styles)(HuesgesAlternativeInspectionPlace));



// WEBPACK FOOTER //
// ./src/routes/inspection/container/HuesgesAlternativeInspectionPlaceFormData.tsx